import React from "react";
import "./PrivacyPolicy.scss";
import { privacyPolicyData } from "../../data/data";

const PrivacyPolicy = ({ onClose }) => {
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="privacy-policy-overlay" onClick={handleOverlayClick}>
      <div className="privacy-policy-popup">
        <h1>{privacyPolicyData.title}</h1>
        <p>Effective Date: {privacyPolicyData.effectiveDate}</p>

        {privacyPolicyData.sections.map((section, index) => (
          <div key={index}>
            <h2>{section.title}</h2>
            {section.content.map((paragraph, pIndex) => (
              <p key={pIndex}>{paragraph}</p>
            ))}
            {section.subsections &&
              section.subsections.map((subsection, subIndex) => (
                <div key={subIndex}>
                  <h3>{subsection.title}</h3>
                  {subsection.content.map((paragraph, pIndex) => (
                    <p key={pIndex}>{paragraph}</p>
                  ))}
                </div>
              ))}
          </div>
        ))}
        <div className="close-button-container">
          <button onClick={onClose} className="close-button">
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
